<template>
  <SpinnerOverlay />
  <ConfirmDialog />
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
  <TheFooter />
</template>

<script>
import LandingPage from "@/views/LandingPage.vue";
import TheFooter from "@/components/TheFooter.vue";
import SpinnerOverlay from "./components/animations/SpinnerOverlay.vue";
import ConfirmDialog from "./components/animations/ConfirmDialog.vue";

export default {
  name: "App",
  components: {
    LandingPage,
    TheFooter,
    SpinnerOverlay,
    ConfirmDialog,
  },
};
</script>
<style>
/* Transition effects */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
